import React from 'react';

import _ from 'lodash';

import Table from 'components/Table';
import Button from 'components/Button';
import {DetailTenantInfo} from 'components/TenantInfo';

import './styles.css';

const AffordabilityRow = ({affordability, openAffordabilityModal}) => (
  <Table.Row
    className="affordabilityRow"
    onClick={() => openAffordabilityModal(affordability.id)}>
    <Table.Cell>
      <DetailTenantInfo tenant={affordability.agreementUser} />
    </Table.Cell>
    <Table.Cell>{affordability.role}</Table.Cell>
  </Table.Row>
);

const AffordabilityTable = ({
  affordabilities,
  tenants,
  guarantor,
  openAffordabilityModal,
  openAssessAffordabilityModal,
  affordabilityPassed
}) => {
  const primaryTenant = tenants.find(t => t.isPrimary === true);
  const secondaryTenant = tenants.find(t => t.isPrimary === false);
  let primaryTenantAffordability,
    secondaryTenantAffordability,
    guarantorAffordability;

  if (!_.isEmpty(affordabilities)) {
    if (primaryTenant) {
      primaryTenantAffordability = affordabilities.find(
        affordability =>
          affordability.agreementUserId === primaryTenant.agreementUserId
      );

      if (primaryTenantAffordability) {
        primaryTenantAffordability = {
          ...primaryTenantAffordability,
          agreementUser: primaryTenant,
          role: 'Primary'
        };
      }
    }

    if (secondaryTenant) {
      secondaryTenantAffordability = affordabilities.find(
        affordability =>
          affordability.agreementUserId === secondaryTenant.agreementUserId
      );

      if (secondaryTenantAffordability) {
        secondaryTenantAffordability = {
          ...secondaryTenantAffordability,
          agreementUser: secondaryTenant,
          role: 'Secondary'
        };
      }
    }

    if (guarantor) {
      guarantorAffordability = affordabilities.find(
        affordability =>
          affordability.agreementUserId === guarantor.agreementUserId
      );

      if (guarantorAffordability) {
        guarantorAffordability = {
          ...guarantorAffordability,
          agreementUser: guarantor,
          role: 'Guarantor'
        };
      }
    }
  }

  return (
    <div className="AffordabilityTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem className="name" heading="Name" />
          <Table.HeaderItem className="role" heading="Role" />
        </Table.Header>
        <Table.Body>
          {primaryTenantAffordability && (
            <AffordabilityRow
              affordability={primaryTenantAffordability}
              openAffordabilityModal={openAffordabilityModal}
            />
          )}
          {secondaryTenantAffordability && (
            <AffordabilityRow
              affordability={secondaryTenantAffordability}
              openAffordabilityModal={openAffordabilityModal}
            />
          )}
          {guarantorAffordability && (
            <AffordabilityRow
              affordability={guarantorAffordability}
              openAffordabilityModal={openAffordabilityModal}
            />
          )}
        </Table.Body>
      </Table>
      <div className="options">
        <Button
          className="assessAffordability"
          blue
          disabled={affordabilityPassed}
          onClick={openAssessAffordabilityModal}>
          Assess Affordabilty
        </Button>
      </div>
    </div>
  );
};

export default AffordabilityTable;
